import { FeatureFlagStore } from './feature-flag.store'

import { getFlags } from './helpers'

import { DefaultFlags, Flags } from '@/constants/feature-flag'

export const loadFlags = async () => {
  const flags = await getFlags()
  FeatureFlagStore.setState({ flags })
}

export const getFeatureFlag = <K extends Flags[keyof Flags]>(
  flagKey: K,
): DefaultFlags[K] =>
  FeatureFlagStore.getState().flags[flagKey] as DefaultFlags[K]
